(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require(undefined));
	else if(typeof define === 'function' && define.amd)
		define(["plesk-ui-library"], factory);
	else if(typeof exports === 'object')
		exports["Jsw"] = factory(require(undefined));
	else
		root["Jsw"] = factory(root[undefined]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_0__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 182);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/* no static exports found */
/* all exports used */
/*!*******************************************!*\
  !*** external {"amd":"plesk-ui-library"} ***!
  \*******************************************/
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_0__;

/***/ }),

/***/ 153:
/* no static exports found */
/* all exports used */
/*!******************************************!*\
  !*** ./views/admin/about/index/About.js ***!
  \******************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _uiLibrary = __webpack_require__(/*! @plesk/ui-library */ 0);

var _Flipper = __webpack_require__(/*! ./Flipper */ 181);

var _Flipper2 = _interopRequireDefault(_Flipper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

var About = function About(_ref) {
    var aboutPleskSrc = _ref.aboutPleskSrc,
        devTeamSrc = _ref.devTeamSrc,
        productName = _ref.productName,
        panelVersion = _ref.panelVersion,
        patch = _ref.patch,
        pleskKeyId = _ref.pleskKeyId,
        linkEula = _ref.linkEula,
        linkForum = _ref.linkForum,
        linkFacebook = _ref.linkFacebook,
        linkTwitter = _ref.linkTwitter,
        linkSite = _ref.linkSite,
        linkBlog = _ref.linkBlog;
    return (0, _uiLibrary.createElement)(
        _uiLibrary.Fragment,
        null,
        (0, _uiLibrary.createElement)(_Flipper2.default, {
            className: 'plesk-about',
            front: (0, _uiLibrary.createElement)(
                'figure',
                { className: 'about-image' },
                (0, _uiLibrary.createElement)('img', { src: aboutPleskSrc })
            ),
            back: (0, _uiLibrary.createElement)(
                'figure',
                { className: 'about-image' },
                (0, _uiLibrary.createElement)('img', { src: devTeamSrc })
            )
        }),
        (0, _uiLibrary.createElement)(
            'p',
            null,
            productName,
            (0, _uiLibrary.createElement)('br', null),
            (0, _uiLibrary.createElement)(_uiLibrary.Translate, { content: 'panelVersion' }),
            ' ',
            panelVersion,
            patch ? (0, _uiLibrary.createElement)(
                'span',
                null,
                ' ',
                (0, _uiLibrary.createElement)(_uiLibrary.Translate, { content: 'installedPatchVersion', params: { patch: patch } })
            ) : null
        ),
        (0, _uiLibrary.createElement)(
            'p',
            null,
            (0, _uiLibrary.createElement)(_uiLibrary.Translate, { content: 'licenseKey' }),
            ': ' + pleskKeyId + ' | ',
            (0, _uiLibrary.createElement)(
                'a',
                { href: '/plesk/license/' },
                (0, _uiLibrary.createElement)(_uiLibrary.Translate, { content: 'linkLicenseManagement' })
            )
        ),
        (0, _uiLibrary.createElement)(
            'p',
            null,
            (0, _uiLibrary.createElement)(_uiLibrary.Translate, { content: 'productDescription' })
        ),
        (0, _uiLibrary.createElement)(
            'ul',
            null,
            (0, _uiLibrary.createElement)(
                'li',
                null,
                (0, _uiLibrary.createElement)(_uiLibrary.Translate, {
                    content: 'visitSite',
                    params: { link: (0, _uiLibrary.createElement)(
                            'a',
                            { href: linkSite, target: '_blank' },
                            (0, _uiLibrary.createElement)(_uiLibrary.Translate, { content: 'linkSite' })
                        ) }
                })
            ),
            (0, _uiLibrary.createElement)(
                'li',
                null,
                (0, _uiLibrary.createElement)(_uiLibrary.Translate, {
                    content: 'visitBlog',
                    params: { link: (0, _uiLibrary.createElement)(
                            'a',
                            { href: linkBlog, target: '_blank' },
                            (0, _uiLibrary.createElement)(_uiLibrary.Translate, { content: 'linkBlog' })
                        ) }
                })
            ),
            (0, _uiLibrary.createElement)(
                'li',
                null,
                (0, _uiLibrary.createElement)(_uiLibrary.Translate, { content: 'followUs' }),
                ': ',
                (0, _uiLibrary.createElement)(
                    'a',
                    { href: linkFacebook, target: '_blank' },
                    'Facebook'
                ),
                ' | ',
                (0, _uiLibrary.createElement)(
                    'a',
                    { href: linkTwitter, target: '_blank' },
                    'Twitter'
                )
            ),
            (0, _uiLibrary.createElement)(
                'li',
                null,
                (0, _uiLibrary.createElement)(_uiLibrary.Translate, {
                    content: 'visitForum',
                    params: { link: (0, _uiLibrary.createElement)(
                            'a',
                            { href: linkForum, target: '_blank' },
                            (0, _uiLibrary.createElement)(_uiLibrary.Translate, { content: 'linkForum' })
                        ) }
                })
            )
        ),
        (0, _uiLibrary.createElement)(
            'p',
            null,
            (0, _uiLibrary.createElement)(_uiLibrary.Translate, { content: 'copyright' })
        ),
        (0, _uiLibrary.createElement)(
            'p',
            null,
            (0, _uiLibrary.createElement)(_uiLibrary.Translate, {
                content: 'readEula',
                params: { link: (0, _uiLibrary.createElement)(
                        'a',
                        { href: linkEula, target: '_blank' },
                        (0, _uiLibrary.createElement)(_uiLibrary.Translate, { content: 'linkEula' })
                    ) }
            })
        )
    );
};

About.propTypes = {
    aboutPleskSrc: _uiLibrary.PropTypes.string.isRequired,
    devTeamSrc: _uiLibrary.PropTypes.string.isRequired,
    productName: _uiLibrary.PropTypes.string.isRequired,
    panelVersion: _uiLibrary.PropTypes.string.isRequired,
    patch: _uiLibrary.PropTypes.string,
    pleskKeyId: _uiLibrary.PropTypes.string.isRequired,
    linkEula: _uiLibrary.PropTypes.string.isRequired,
    linkForum: _uiLibrary.PropTypes.string.isRequired,
    linkFacebook: _uiLibrary.PropTypes.string.isRequired,
    linkTwitter: _uiLibrary.PropTypes.string.isRequired,
    linkSite: _uiLibrary.PropTypes.string.isRequired,
    linkBlog: _uiLibrary.PropTypes.string.isRequired
};

About.defaultProps = {
    patch: null
};

exports.default = About;

/***/ }),

/***/ 181:
/* no static exports found */
/* all exports used */
/*!********************************************!*\
  !*** ./views/admin/about/index/Flipper.js ***!
  \********************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _uiLibrary = __webpack_require__(/*! @plesk/ui-library */ 0);

var _classnames = __webpack_require__(/*! classnames */ 70);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright 1999-2017. Plesk International GmbH. All rights reserved.

var Flipper = function (_Component) {
    _inherits(Flipper, _Component);

    function Flipper() {
        _classCallCheck(this, Flipper);

        var _this = _possibleConstructorReturn(this, (Flipper.__proto__ || Object.getPrototypeOf(Flipper)).call(this));

        _this.handleFlip = function () {
            _this.setState({
                flipped: !_this.state.flipped
            });
        };

        _this.state = {
            flipped: false
        };
        return _this;
    }

    _createClass(Flipper, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                className = _props.className,
                front = _props.front,
                back = _props.back;
            var flipped = this.state.flipped;


            return (0, _uiLibrary.createElement)(
                'div',
                { className: (0, _classnames2.default)('flip-container', { flipped: flipped }, className) },
                (0, _uiLibrary.createElement)(
                    'div',
                    { className: 'flipper', onDoubleClick: this.handleFlip },
                    (0, _uiLibrary.createElement)(
                        'div',
                        { className: 'front' },
                        front
                    ),
                    (0, _uiLibrary.createElement)(
                        'div',
                        { className: 'back' },
                        back
                    )
                )
            );
        }
    }]);

    return Flipper;
}(_uiLibrary.Component);

Flipper.propTypes = {
    className: _uiLibrary.PropTypes.string,
    front: _uiLibrary.PropTypes.any.isRequired,
    back: _uiLibrary.PropTypes.any.isRequired
};

Flipper.defaultProps = {
    className: null
};

exports.default = Flipper;

/***/ }),

/***/ 182:
/* no static exports found */
/* all exports used */
/*!******************************************!*\
  !*** ./views/admin/about/index/index.js ***!
  \******************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _About = __webpack_require__(/*! ./About */ 153);

var _About2 = _interopRequireDefault(_About);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _About2.default; // Copyright 1999-2017. Plesk International GmbH. All rights reserved.

/***/ }),

/***/ 70:
/* no static exports found */
/* all exports used */
/*!***************************************************************************************************************!*\
  !*** /home/builder/buildbot/microupdate/PLESK_17_8-cl7/build/buck-out/gen/~/node_modules/classnames/index.js ***!
  \***************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(null, arg));
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ })

/******/ });
});


// WEBPACK FOOTER //
// javascript/views/admin/about/index.js